module.exports = __webpack_public_path__ + "media/application/images/2018/facebook@2x-4ab10a8636de87c1e3f8fb9b2535fbc9.png";